<template>
    <v-form>
        <div class="az-form-content dados-gerais">
          <div v-if="dadosGeraisVisualizacao.situacao === 'SUSPENSA'"
               class="alert-suspensa mb-4 p-3"
               style="background-color: #fff8e1;
                border-left: 4px solid #ffa000;
                 border-radius: 4px;
                 padding: 10px;
                  color: #795548;">
            <strong>Compra Direta Suspensa! </strong>
            <a href="#" @click.prevent="abrirModalSuspensao"
               style="color: inherit; margin-left: 4px; text-decoration: underline;">Ver Motivo
            </a>
          </div>

            <v-container fluid grid-list-xl white>

                <painel-processo-visualizacao v-model="dadosGeraisVisualizacao"/>

                <painel-compra-direta-visualizacao v-model="dadosGeraisVisualizacao"
                                                   :exibirFimEnvioPropostasELances="exibirFimEnvioPropostasELances"
                                                   :tempoRandomicoLance="tempoRandomicoLance"
                                                   :lei14133UsaTempoRandomicoLance="lei14133UsaTempoRandomicoLance"
                                                   :ehALei14_133="ehALei14_133"
                                                   :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"/>

                <timeline-eventos-pos-publicacao v-if="eventos && eventos.length > 0" :eventos="eventos"/>

                <painel-anexo-edicao v-if="exibirAnexoEdicao"
                                     v-model="dadosGeraisVisualizacao.anexos"
                                     :documentos="documentos"
                                     :paginas="null"
                                     :paginacao="null"
                                     :situacaoCompraDireta="dadosGeraisVisualizacao.situacao"
                                     @excluirAnexo="tratarEventoDeRemoverAnexo"
                                     @adicionarAnexo="tratarEventoAdicionarAnexo"
                                     @atualizarTipoAnexo="tratarEventoAtualizarTipoAnexo"
                                     @downloadAnexo="tratarEventDownloadAnexo"
                                     @atualizarSituacaoAnexo="exibirModalAtualizarSituacaoAnexo"/>

                <painel-anexo-visualizacao v-else
                                           v-model="dadosGeraisVisualizacao.anexos"
                                           :documentos="documentos"
                                           :situacaoCompraDireta="dadosGeraisVisualizacao.situacao"
                                           :paginas="null"
                                           :paginacao="null"
                                           @downloadAnexo="tratarEventDownloadAnexo"
                                           @atualizarSituacaoAnexo="exibirModalAtualizarSituacaoAnexo"/>
            </v-container>
        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <botao-salvar v-if="ehRecursoFederalETransferenciaVoluntaria()" @salvar="atualizarDadosMaisBrasil(dadosGeraisVisualizacao)"/>
            <botao-avancar @avancar="tratarEventoAvancar"/>
        </div>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoAtivoInativo"
                              :titulo="titulo"
                              :textoSecundario="mensagem"
                              @confirmado="tratarEventoDeAtualizarSituacaoAnexo"
                              @recusado="fecharModalAtualizarSituacaoAnexo"/>

        <v-dialog v-model="mostrarModalSuspensao" persistent max-width="800px">
            <modal-suspender-compra-direta
                v-model="dadosGeraisVisualizacao"
                :modo-visualizacao="false"
                :motivo-suspensao="dadosGeraisVisualizacao.justificativaSuspensao"
                :anexo-suspensao="dadosGeraisVisualizacao.anexoSuspensao"
                @fecharModalSuspensao="fecharModalSuspensao"
                @salvarSuspensao="tratarEventoSuspender"
                @downloadAnexo="tratarEventDownloadAnexo"/>
        </v-dialog>
    </v-form>
</template>

<script>
import {actionTypes} from '@/core/constants'
import PainelCompraDiretaVisualizacao from '@/views/pages/commons/painel/painel-compra-direta/PainelCompraDiretaVisualizacao'
import PainelProcessoVisualizacao from '@/views/pages/commons/painel/painel-processo/PainelProcessoVisualizacao'
import PainelAnexoVisualizacao from '@/views/pages/commons/painel/painel-anexo/PainelAnexoVisualizacao'
import PainelAnexoEdicao from '@/views/pages/commons/painel/painel-anexo/PainelAnexoEdicao'
import ModalSuspenderCompraDireta from '@/views/pages/comprador/execucao-compra-direta/acoes/ModalSuspenderCompraDireta'
import {mapState} from 'vuex'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import TimelineEventosPosPublicacao from '@/views/components/TimelineEventosPosPublicacao.vue'

export default {
    name: 'DadosGeraisVisualizacao',
    components: {
        TimelineEventosPosPublicacao,
        PainelCompraDiretaVisualizacao,
        PainelAnexoEdicao,
        PainelAnexoVisualizacao,
        PainelProcessoVisualizacao,
        ModalSuspenderCompraDireta,
    },
    data() {
        return {
            dadosGeraisVisualizacao: {
                anexos: []
            },
            compraDiretaId: null,
            documentos: [],
            exibirAnexoEdicao: false,
            anexoId: null,
            situacaoAnexo: null,
            mostrarDialogoAtivoInativo: false,
            titulo: '',
            mensagem: '',
            eventos: null,
            mostrarModalSuspensao: false,
        }
    },
    computed: {
        ...mapState(['loki', 'parametros', 'dadosGerais']),
        modoDeCriacaoManual() {
            return this.parametros.propriedadesCompraDiretas.modoCriacao === 'MANUAL'
        },
        exibirFimEnvioPropostasELances(){
            return this.exibirFimPropostasELances(this.dadosGerais.amparoLegal)
        },
        tempoRandomicoLance() {
            return this.parametros.propriedadesCompraDiretas.tempoRandomicoLance
        },
        lei14133UsaTempoRandomicoLance() {
            return this.parametros.propriedadesCompraDiretas.lei14133UtilizarTempoRandomicoLance
        },
        ehALei14_133(){
            return this.ehLei14_133(this.dadosGerais.amparoLegal)
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.dadosGerais?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDocumentos()
            await this.buscarDadosGerais()
            await this.buscarEventosPosPublicacao()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    watch: {
        'dadosGerais': {
            handler(novoValor) {
                this.dadosGeraisVisualizacao = novoValor
            },
            deep: true
        }
    },
    methods: {
        async atualizarDadosMaisBrasil(dadosGerais){
            await this.validarCampos()
            this.setMensagemLoading('Salvando as alterações...')
            await this.$store.dispatch(actionTypes.COMPRADOR.SALVAR_DADOS_GERAIS_NOVA_COMPRA, {
                atualizarApenasRecursoFederal: true,
                id: dadosGerais.id,
                recursoFederal: dadosGerais.recursoFederal,
                tipoTransferencia: dadosGerais.tipoTransferencia,
                numeroConvenio: dadosGerais.numeroConvenio,
                anoInstrumento: dadosGerais.anoInstrumento,
                legislacao: dadosGerais.legislacao,
                tipoObjeto: dadosGerais.tipoObjeto,
                origemRecurso: dadosGerais.origemRecurso
            })
            this.mostrarNotificacaoSucessoDefault()
        },
        async validarCampos(){
            const estaValidado = await this.$validator._base.validateAll()
            if(!estaValidado){
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        },
        async buscarDocumentos() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS, this.compraDiretaId)
            this.documentos = this.$store.state.documentos
        },
        async buscarDadosGerais() {
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS, this.compraDiretaId)
            this.dadosGeraisVisualizacao = this.$store.state.dadosGerais
            this.anexos = this.dadosGerais.anexos
            this.verificarSePodeAnexarArquivo()
        },
        async buscarEventosPosPublicacao(){
            const {eventos} = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_EVENTOS_POS_PUBLICACAO, this.compraDiretaId)
            this.eventos = eventos
        },
        async tratarEventoAdicionarAnexo(anexo) {
            anexo.situacao = 'ATIVO'
            const dados = {
                compraDiretaId: this.compraDiretaId,
                anexo
            }
            await this.$store.dispatch(actionTypes.ADICIONAR_ANEXO_DADOS_GERAIS, dados)
        },
        async tratarEventoAtualizarTipoAnexo(anexo) {
            const anexoObjeto = {
                compraDiretaId: this.compraDiretaId,
                anexo: anexo
            }
            const data = await this.$store.dispatch(actionTypes.ATUALIZAR_TIPO_ANEXO_DADOS_GERAIS, anexoObjeto)
            anexo.situacao = data.situacao
            this.mostrarNotificacaoSucesso('Anexo atualizado com sucesso.')
        },
        async tratarEventoDeAtualizarSituacaoAnexo(){
            const itemObj = {
                compraDiretaId: this.compraDiretaId,
                anexoId: this.anexoId,
                situacao: this.situacaoAnexo
            }
            this.fecharModalAtualizarSituacaoAnexo()
            await this.$store.dispatch(actionTypes.COMPRADOR.ATUALIZAR_SITUACAO_ANEXO_COMPRA_DIRETA, itemObj)
            this.mostrarNotificacaoSucesso('Situação alterada com sucesso.')
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        async tratarEventoAvancar() {
            if(this.ehRecursoFederalETransferenciaVoluntaria()) {
                await this.atualizarDadosMaisBrasil(this.dadosGeraisVisualizacao)
            }
            await this.$router.push({name: 'ItensLotesVisualizacao', params: this.compraDiretaId})
        },
        tratarEventoVoltar() {
            this.$router.push({name: this.$store.state.rota.origem})
        },
        exibirModalAtualizarSituacaoAnexo(id, situacao) {
            this.anexoId = id
            this.situacaoAnexo = situacao
            if (this.situacaoAnexo === 'ATIVO') {
                this.titulo = 'Ativar Anexo'
                this.mensagem = 'Tem certeza que deseja ativar o anexo?'
            } else {
                this.titulo = 'Inativar Anexo'
                this.mensagem = 'Tem certeza que deseja inativar o anexo?'
            }
            this.mostrarDialogoAtivoInativo = true
        },
        fecharModalAtualizarSituacaoAnexo() {
            this.anexoId = null
            this.situacaoAnexo = null
            this.titulo = ''
            this.mensagem = ''
            this.mostrarDialogoAtivoInativo = false
        },
        verificarSePodeAnexarArquivo() {
            if (
                azAuth(this.$store.state.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior']) &&
                    this.compraDiretaSituacaoLegal()
            ) {
                this.exibirAnexoEdicao = true
            }
        },
        compraDiretaSituacaoLegal(){
            return ['AGUARDANDO_ABERTURA', 'ABERTA', 'ENCERRADA', 'EM_ANALISE', 'REANALISE'].includes(this.dadosGeraisVisualizacao.situacao)
        },
        ehRecursoFederalETransferenciaVoluntaria()
        {
            return (this.dadosGeraisVisualizacao.recursoFederal && this.ehTransferenciaVoluntarios())
        },
        ehTransferenciaVoluntarios(){
            return this.dadosGeraisVisualizacao.tipoTransferencia === 'VOLUNTARIAS'
        },
        async tratarEventoDeRemoverAnexo(id) {
            const objetoASerRemovido = {
                compraDiretaId: this.compraDiretaId,
                anexoId: id
            }
            await this.$store.dispatch(actionTypes.REMOVER_ANEXO_DADOS_GERAIS, objetoASerRemovido)
            this.mostrarNotificacaoSucesso('Arquivo excluído com sucesso.')
        },
        async tratarEventDownloadAnexo(anexoInfo){
            const anexoDoc = anexoInfo.anexo
            if(anexoDoc.id && anexoDoc.uri)
                await this.$store.dispatch(actionTypes.DOWNLOAD_ANEXO, anexoDoc)
            else{
                const dados = {
                    compraDiretaId: this.compraDiretaId,
                    idVirtualizado: anexoDoc.idVirtualizado,
                    nomeArquivo: anexoDoc.nomeDocumento,
                    opcaoDownloadVirtualizacao: anexoInfo.tipoDownload,
                    noProcessoDigital: anexoDoc.noProcessoDigital
                }
                await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTO_VIRTUALIZADO, dados)
            }
        },
        async abrirModalSuspensao() {
            try {
                await this.buscarDadosGerais()
                this.mostrarModalSuspensao = true
            } catch (error) {
                this.mostrarNotificacaoErro('Erro ao buscar dados da compra direta.')
            }
        },
        fecharModalSuspensao() {
            this.mostrarModalSuspensao = false
        },
        async tratarEventoSuspender(objModal) {
            try {
                const objParaSuspender = {
                    compraDiretaId: this.compraDiretaId,
                    dados: {
                        justificativaSuspensao: objModal.motivo,
                    }
                }

                if (objModal.arquivo) {
                    objParaSuspender.dados.nomeArquivo = objModal.arquivo.nome

                    if (objModal.arquivo.uri) {
                        objParaSuspender.dados.uri = objModal.arquivo.uri
                    } else if (objModal.arquivo.file) {
                        objParaSuspender.dados.uri = await this.uploadArquivo(objModal.arquivo.file)
                    }
                }

                await this.$store.dispatch(actionTypes.SUSPENDER_COMPRA_DIRETA, objParaSuspender)
                this.mostrarNotificacaoSucesso('Compra direta suspensa com sucesso.')
                this.fecharModalSuspensao()

                await this.buscarDadosGerais()
            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao suspender compra direta.')
            }
        },
        async uploadArquivo(arquivo) {
            if (!arquivo) return null
            
            const formData = new FormData()
            formData.append('file', arquivo)

            const { arquivo: uploadedFile } = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, formData)

            return uploadedFile.uri
        }
    }
}
</script>

<style scoped lang="stylus">

</style>
